// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
import { calculateAge,                } from './date.mjs';
import { reduceToDigit, reduceWithMasters } from './reduction.mjs';

export const LEGACY_METHODOLOGY_VERSION = 'legacy-observed-1'         ;
const KARMIC_DEBTS = new Set([13, 14, 16, 19]);

























/**
 * Reproduces the date formulas observed in the legacy app for comparison only.
 * It must not be used as the approved product methodology.
 */
export function calculateLegacyDateProfile(
  birthDate           ,
  asOfDate           ,
)                    {
  const day = reduceWithMasters(birthDate.day).value;
  const month = reduceWithMasters(birthDate.month).value;
  const year = reduceWithMasters(birthDate.year).value;
  const originRaw = day + month + year;
  const origin = reduceWithMasters(originRaw).value;

  const first = reduceWithMasters(day + month).value;
  const second = reduceWithMasters(day + year).value;
  const third = reduceWithMasters(first + second).value;
  const fourth = reduceWithMasters(month + year).value;

  const firstEndsAt = 36 - origin;
  const secondStartsAt = firstEndsAt + 1;
  const secondEndsAt = secondStartsAt + 9;
  const thirdStartsAt = secondEndsAt + 1;
  const thirdEndsAt = thirdStartsAt + 9;
  const fourthStartsAt = thirdEndsAt + 1;
  const age = calculateAge(birthDate, asOfDate);

  const currentPinnacle =
    age <= firstEndsAt
      ? first
      : age <= secondEndsAt
        ? second
        : age <= thirdEndsAt
          ? third
          : fourth;

  const firstChallenge = Math.abs(day - month);
  const secondChallenge = Math.abs(day - year);
  const thirdChallenge = Math.abs(firstChallenge - secondChallenge);
  const fourthChallenge = Math.abs(month - year);

  const reducedDayAndMonth = reduceToDigit(day + month).value;
  const reducedReferenceYear = reduceToDigit(asOfDate.year).value;
  const personalYear = reduceToDigit(reducedDayAndMonth + reducedReferenceYear).value;
  const personalMonths = Array.from(
    { length: 12 },
    (_, index) => reduceWithMasters(personalYear + index + 1).value,
  );

  return {
    methodologyVersion: LEGACY_METHODOLOGY_VERSION,
    components: { day, month, year },
    birthNumber: birthDate.day,
    origin,
    originRaw,
    originKarmicDebt: KARMIC_DEBTS.has(originRaw) ? originRaw : null,
    pinnacles: [first, second, third, fourth],
    pinnacleAges: {
      firstEndsAt,
      second: [secondStartsAt, secondEndsAt],
      third: [thirdStartsAt, thirdEndsAt],
      fourthStartsAt,
    },
    currentPinnacle,
    challenges: [firstChallenge, secondChallenge, thirdChallenge, fourthChallenge],
    personalYear,
    personalMonths,
  };
}
